var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed } from "mobx";
import { NamedRoutes } from "./NamedRoutes";
import { getObservableT } from "../Infra/i18next";
import { NOT_LOADED } from "../Infra/RemoteData";
import { ContactMethod } from "healthex-common/consentconfig.dtos";
const t = getObservableT("patients");
export class HeaderViewModelMobile {
    constructor(container) {
        this.authManager = container.authManager;
        this.routingUIManager = container.routingUIManager;
        this.dashboardUIManager = container.patientResearchDashboardUIManager;
        this.appUIManager = container.appUIManager;
    }
    get hasUnifiedRecordExpired() {
        return this.dashboardUIManager.hasUnifiedRecordExpired;
    }
    get unifiedRecordSummary() {
        return this.dashboardUIManager.unifiedRecordSummary;
    }
    get isUnifiedRecordDownloadable() {
        return this.dashboardUIManager.isUnifiedRecordDownloadable;
    }
    get isUnifiedRecordProcessing() {
        return this.dashboardUIManager.isUnifiedRecordProcessing;
    }
    get mobilePageTitle() {
        var _a;
        switch ((_a = this.routingUIManager.currentRoute) === null || _a === void 0 ? void 0 : _a.routeName) {
            case NamedRoutes.PATIENT_SHARING.routeName:
                return t("Sharing");
            case NamedRoutes.PATIENT_SHARING_DETAILS.routeName:
                return t("Details");
            case NamedRoutes.PATIENT_HOME.routeName: {
                if (this.authManager.firstName) {
                    return t("Hi, {{ firstName }}!", { firstName: this.authManager.firstName });
                }
                else {
                    return t("Hi!");
                }
            }
            default:
                return null;
        }
    }
    get mobilePageText() {
        var _a;
        switch ((_a = this.routingUIManager.currentRoute) === null || _a === void 0 ? void 0 : _a.routeName) {
            case NamedRoutes.PATIENT_SHARING.routeName:
                return t("Manage who can access your health records");
            case NamedRoutes.PATIENT_SHARING_DETAILS.routeName:
                return null;
            case NamedRoutes.PATIENT_HOME.routeName: {
                if (this.isUnifiedRecordDownloadable === NOT_LOADED)
                    return null;
                if (this.isUnifiedRecordDownloadable && this.hasUnifiedRecordExpired !== true) {
                    return this.getTextForContactMethodWhenUnifiedRecordSent(t("We’ve emailed your copy of your records to {{ email }}.", {
                        email: this.authManager.email,
                    }), t("We’ve sent your copy of your records to {{ phone }}.", {
                        phone: this.authManager.formattedPhone,
                    }));
                }
                else if (this.isUnifiedRecordProcessing === true) {
                    const commonText = t("We’re still working on your HealthEx Unified Record.");
                    return this.getTextForPreferredContactMethod(`${commonText} ${t("Once we’re done, we'll email a copy to {{ email }}.", {
                        email: this.authManager.email,
                    })}`, `${commonText} ${t("Once we’re done, we'll send it to {{ phone }}.", {
                        phone: this.authManager.formattedPhone,
                    })}`);
                }
                else {
                    return t("See your health history, all in one secure document.");
                }
            }
            default:
                return null;
        }
    }
    getTextForPreferredContactMethod(defaultPreferredContactMethodText, phoneText) {
        if (this.dashboardUIManager.preferredContactMethod === NOT_LOADED)
            return null;
        if (this.dashboardUIManager.preferredContactMethod === ContactMethod.TEXT) {
            return phoneText;
        }
        else {
            return defaultPreferredContactMethodText;
        }
    }
    getTextForContactMethodWhenUnifiedRecordSent(defaultPreferredContactMethodText, phoneText) {
        if (this.dashboardUIManager.contactMethodWhenUnifiedRecordSent === NOT_LOADED)
            return null;
        if (this.dashboardUIManager.contactMethodWhenUnifiedRecordSent === ContactMethod.TEXT) {
            return phoneText;
        }
        else {
            return defaultPreferredContactMethodText;
        }
    }
    get headerGap() {
        var _a;
        switch ((_a = this.routingUIManager.currentRoute) === null || _a === void 0 ? void 0 : _a.routeName) {
            case NamedRoutes.PATIENT_SHARING_DETAILS.routeName:
                return 16;
            case NamedRoutes.PATIENT_SHARING.routeName:
            case NamedRoutes.PATIENT_HOME.routeName:
                return 40;
            default:
                return 0;
        }
    }
    get headerPaddingBottom() {
        var _a;
        switch ((_a = this.routingUIManager.currentRoute) === null || _a === void 0 ? void 0 : _a.routeName) {
            case NamedRoutes.PATIENT_SHARING.routeName:
                return 12;
            case NamedRoutes.PATIENT_SHARING_DETAILS.routeName:
                return 0;
            case NamedRoutes.PATIENT_HOME.routeName:
                return 24;
            default:
                return 0;
        }
    }
    get mobileOnBack() {
        var _a;
        switch ((_a = this.routingUIManager.currentRoute) === null || _a === void 0 ? void 0 : _a.routeName) {
            case NamedRoutes.PATIENT_SHARING_DETAILS.routeName:
                return () => this.routingUIManager.navigateTo(NamedRoutes.PATIENT_SHARING);
            default:
                return null;
        }
    }
    get showSimplifiedHeader() {
        var _a;
        return ((_a = this.routingUIManager.currentRoute) === null || _a === void 0 ? void 0 : _a.routeName) === NamedRoutes.PATIENT_SHARING_DETAILS.routeName;
    }
    logoOnClick() {
        var _a;
        if (((_a = this.routingUIManager.currentRoute) === null || _a === void 0 ? void 0 : _a.routeName) === NamedRoutes.PATIENT_ACCOUNT_DELETE_CONFIRMATION.routeName) {
            this.routingUIManager.navigateTo(NamedRoutes.LOGIN_AS_PATIENT);
        }
        else {
            this.appUIManager.navigateToHome();
        }
    }
}
__decorate([
    computed
], HeaderViewModelMobile.prototype, "hasUnifiedRecordExpired", null);
__decorate([
    computed
], HeaderViewModelMobile.prototype, "unifiedRecordSummary", null);
__decorate([
    computed
], HeaderViewModelMobile.prototype, "isUnifiedRecordDownloadable", null);
__decorate([
    computed
], HeaderViewModelMobile.prototype, "isUnifiedRecordProcessing", null);
__decorate([
    computed
], HeaderViewModelMobile.prototype, "mobilePageTitle", null);
__decorate([
    computed
], HeaderViewModelMobile.prototype, "mobilePageText", null);
__decorate([
    computed
], HeaderViewModelMobile.prototype, "headerGap", null);
__decorate([
    computed
], HeaderViewModelMobile.prototype, "headerPaddingBottom", null);
__decorate([
    computed
], HeaderViewModelMobile.prototype, "mobileOnBack", null);
__decorate([
    computed
], HeaderViewModelMobile.prototype, "showSimplifiedHeader", null);
